import styles from "./card-header-and-text.module.scss";
import classnames from "classnames";
import Divider from "../Divider/divider";
import SbTextBlock from "../TextBlock/sb-text-block";
import { CardHeaderAndTextStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: CardHeaderAndTextStoryblok;
}

const CardHeaderAndText = (props: Props) => {
  const [content] = props.blok.content || [];

  return (
    <div className={styles.wrapper}>
      {props.blok.header ? (
        <div className={styles.header}>{props.blok.header}</div>
      ) : null}
      {props.blok.subheader ? (
        <div className={classnames(styles.subheader, styles.mt8)}>
          {props.blok.subheader}
        </div>
      ) : null}
      {content ? (
        <>
          <div className={styles.mt16}>
            <Divider />
          </div>
          <div className={classnames(styles.mt16)}>
            <SbTextBlock
              blok={content}
              className={classnames(styles.fontsize16, styles.lineheight24)}
            />
          </div>
        </>
      ) : null}
    </div>
  );
};

export default CardHeaderAndText;
